import { screenPresets, update } from 'presets/data/queryKeyFactory';
import { Preset } from 'presets/interfaces';
import { updatePreset } from 'presets/sources/updatePreset';
import { useMutation, useOptimisticUpdate } from 'query';

export const useUpdatePreset = (screenKey: string) => {
  const { onMutate, onError, onSettled } = useOptimisticUpdate({
    queryKey: screenPresets(screenKey),
    optimisticUpdate: (changedData: Preset, previousData: Preset[]) => {
      return (previousData as Preset[]).map(preset => {
        if (preset.id === changedData.id) {
          return changedData;
        }
        return preset;
      });
    },
  });

  const updateMutation = useMutation(update(), updatePreset, {
    successMessage: () => `Preset updated`,
    refresh: false,
    onMutate,
    onError,
    onSettled,
  });

  const handleAction = async (preset: Preset, state: any) => {
    return updateMutation.mutateAsync({
      ...preset,
      data: state,
    } as any);
  };

  return [handleAction, updateMutation];
};
